import React, { useEffect, useState } from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { getColumnDefsFilter, getColumnDefsFour } from './constants'
import TablePaginationCustom from '../../../../common/TablePagination'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useTranslation } from '../../../../../i18n/I18nProvider'

const VoucherRptDetailedTable = (props) => {
    const { loginData, tableData, setTableData, filterData } = props
    const { translations } = useTranslation()
    const rdcn = translations?.rechargeDebitCreditNote || {}
    const cs = translations?.common || {}
    const columnDefsFour = getColumnDefsFour(translations)
    const columnDefsFilter = getColumnDefsFilter(translations)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [page, setPage] = useState(0)
    const [filterValues, setFilterValues] = useState({});
    const [filteredTableData, setFilteredTableData] = useState(tableData); // Store filtered data

    useEffect(() => {
        // Check if all filter values are empty
        const areFiltersEmpty = Object.values(filterValues).every(value => value === "" || value === undefined);
        if (areFiltersEmpty) {
            setFilteredTableData(tableData); // Restore original data when filters are cleared
            return;
        }
        const filteredDataTemp = tableData.filter((item) => {
            return columnDefsFour?.every((column) => {
                const filterValue = filterValues[column.field]; // Can be 0 or any other value
                const value = item[column.field]; // The value in the row
                if (filterValue !== undefined && filterValue !== "") {
                    return value != null && value.toString().toLowerCase().includes(filterValue.toString().toLowerCase());
                }
                return true;
            });
        });
        setFilteredTableData(filteredDataTemp); // Update filtered data
    }, [filterValues, tableData]); // Add `tableData` to dependency array

    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    };
    return (
        <>
            <Box style={{ padding: '12px 15px 4px 15px' }}>
                <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        style={{
                            '&.MuiTableCell-root': {
                                padding: '6px 8px!important',
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                            <TableRow>
                                {columnDefsFour?.map((col, index) => (
                                    <TableCell key={`CityHeader-${index}`} style={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px'
                                    }}>
                                        {col.headerName}
                                    </TableCell>
                                ))}

                            </TableRow>
                            <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                                {columnDefsFour.map((col, index) => (
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`Contains-${index}`}
                                                    className="field"
                                                    value={filterValues[col.field]}
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder={cs.contains || 'Contains'}
                                                    onChange={(e) => handleChangeContain(e, col.field)}
                                                // onChange={(e) => handleSearchData(e, col.field)}
                                                // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "createBtn" : `Contains-${index - 1}`, index === 11 ? reportData.length > 0 ? `Edit-0` : 'status' : `Contains-${index + 1}`)}
                                                />
                                                <FilterAltIcon style={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                                            </div>
                                        </TableCell>
                                    ) : <TableCell key={`FTH-${index}`}></TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {filteredTableData?.length > 0 ? <TableBody>
                            {(
                                rowsPerPage > 0
                                    ? filteredTableData.slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    : filteredTableData
                            ).map((val, index) => (
                                val?.isSubHeadingRow ?
                                    <TableRow>
                                        <TableCell colSpan={5} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#F5FAFE' }}>
                                            {`${val?.subHeadingData[0]?.caption} ${val?.subHeadingData[0]?.value}`}
                                        </TableCell>
                                        <TableCell colSpan={6} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#F5FAFE', textAlign: 'center' }}>
                                            {`${val?.subHeadingData[1]?.caption} ${val?.subHeadingData[1]?.value}`}
                                        </TableCell>
                                        <TableCell colSpan={5} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#F5FAFE', textAlign: 'right' }}>
                                            {`${val?.subHeadingData[2]?.caption} ${val?.subHeadingData[2]?.value}`}
                                        </TableCell>
                                    </TableRow> :
                                    val?.isTotalRow ?
                                        <TableRow>
                                            <TableCell colSpan={11} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.totalCaption}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.GSTAmt}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.TotalNetAmt}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.TotalPaidAmt}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.Discount}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.NetAmtToRcv}
                                            </TableCell>
                                        </TableRow> :
                                        <TableRow>
                                            <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'left' }}>
                                                {val?.SN}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.VoucherNo}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.VoucherDate}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.BookingDate}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.LRNO}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.Party}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.GSTN}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.PaymentType}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.TransactionType}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.GSTInv}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.GSTDate}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.GSTAmt}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.TotalNetAmt}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.TotalPaidAmt}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.Discount}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.NetAmtToRcv}
                                            </TableCell>
                                        </TableRow>
                            ))}
                        </TableBody> :
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={columnDefsFour?.length}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>}
                    </Table>
                    <Table
                        id='table-to-xls'
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '&.MuiTableCell-root': {
                                padding: '6px 8px!important',
                            },
                        }}
                        style={{ display: 'none' }}
                    >
                        <TableHead style={{ fontWeight: 'bold' }}>
                            <TableRow>
                                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={Math.floor(columnDefsFour.length / 2)}>
                                    <h3 style={{ paddingLeft: '17px' }}>{`${rdcn.partyVoucher || 'Party Voucher'} ${rdcn.detailed || 'Detailed'} Report`} </h3>
                                </TableCell>
                                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={columnDefsFour.length - Math.floor(columnDefsFour.length / 2)}>
                                    <h3 style={{ paddingLeft: '17px' }}>{`${cs.companyName || 'Company Name'} : ${loginData.strCompanyName}`}</h3>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={columnDefsFour.length}></TableCell>
                            </TableRow>
                            <TableRow >
                                {columnDefsFilter
                                    .map((val, index) => (
                                        <TableCell
                                            key={`FTR-${index}`}
                                            style={{
                                                backgroundColor: '#BFE1FF',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                textAlign: 'left',
                                                color: '#444',
                                            }}
                                            colSpan={val.colSpan}
                                        >
                                            {val.headerName}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                            <TableRow >
                                <TableCell key={`FTR-fromDate`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{filterData?.partyCity}</TableCell>
                                <TableCell key={`FTR-toDate`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{filterData?.partyName}</TableCell>
                                <TableCell key={`FTR-partyCity`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{filterData?.voucherType}</TableCell>
                                <TableCell key={`FTR-partyCity`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{filterData?.reportType}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={columnDefsFour.length}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                            <TableRow>
                                {columnDefsFour?.map((col, index) => (
                                    <TableCell key={`CityHeader-${index}`} style={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px'
                                    }}>
                                        {col.headerName}
                                    </TableCell>
                                ))}

                            </TableRow>
                        </TableHead>
                        {tableData?.length > 0 ? <TableBody>
                            {(
                                rowsPerPage > 0
                                    ? tableData.slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    : tableData
                            ).map((val, index) => (
                                val?.isSubHeadingRow ?
                                    <TableRow>
                                        <TableCell colSpan={5} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#F5FAFE' }}>
                                            {`${val?.subHeadingData[0]?.caption} ${val?.subHeadingData[0]?.value}`}
                                        </TableCell>
                                        <TableCell colSpan={6} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#F5FAFE', textAlign: 'center' }}>
                                            {`${val?.subHeadingData[1]?.caption} ${val?.subHeadingData[1]?.value}`}
                                        </TableCell>
                                        <TableCell colSpan={5} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#F5FAFE', textAlign: 'right' }}>
                                            {`${val?.subHeadingData[2]?.caption} ${val?.subHeadingData[2]?.value}`}
                                        </TableCell>
                                    </TableRow> :
                                    val?.isTotalRow ?
                                        <TableRow>
                                            <TableCell colSpan={11} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.totalCaption}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.GSTAmt}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.TotalNetAmt}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.TotalPaidAmt}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.Discount}
                                            </TableCell>
                                            <TableCell colSpan={1} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                                {val?.NetAmtToRcv}
                                            </TableCell>
                                        </TableRow> :
                                        <TableRow>
                                            <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'left' }}>
                                                {val?.SN}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.VoucherNo}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.VoucherDate}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.BookingDate}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.LRNO}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.Party}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.GSTN}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.PaymentType}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.TransactionType}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.GSTInv}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                {val?.GSTDate}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.GSTAmt}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.TotalNetAmt}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.TotalPaidAmt}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.Discount}
                                            </TableCell>
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                {val?.NetAmtToRcv}
                                            </TableCell>
                                        </TableRow>
                            ))}
                        </TableBody> :
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={columnDefsFour?.length}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>}
                    </Table>
                </TableContainer>
                <Box style={{
                    'svg': {
                        color: 'inherit !important'
                    }
                }}>
                    <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                        setPage(newPage)
                    }} handleChangeRowsPerPage={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                    }} />
                </Box>
            </Box>
        </>
    )
}

export default VoucherRptDetailedTable
